export default "__VITE_ASSET__98b3dc47__"